import { motion } from 'framer-motion';
import { User, Store } from 'lucide-react';
import { StarRating } from './StarRating';

export const ReviewCard = ({ review, onReplyAdded }) => {
  const timeAgo = (date) => {
    const now = new Date();
    const reviewDate = new Date(date);
    const diffInDays = Math.floor((now - reviewDate) / (1000 * 60 * 60 * 24));
    
    if (diffInDays === 0) return 'Hoy';
    if (diffInDays === 1) return 'Ayer';
    if (diffInDays < 7) return `Hace ${diffInDays} días`;
    if (diffInDays < 30) return `Hace ${Math.floor(diffInDays / 7)} semanas`;
    return reviewDate.toLocaleDateString('es-ES', { month: 'short', year: 'numeric' });
  };

  return (
    <motion.div
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      className="bg-card rounded-xl border border-border/50 overflow-hidden"
      data-testid="review-card"
    >
      {/* Customer Review */}
      <div className="p-4">
        <div className="flex items-start gap-4">
          {/* Avatar */}
          <div className="w-10 h-10 rounded-full bg-local-sage/10 flex items-center justify-center flex-shrink-0">
            <User className="w-5 h-5 text-local-sage" />
          </div>
          
          {/* Content */}
          <div className="flex-1 min-w-0">
            <div className="flex items-start justify-between gap-2 mb-2">
              <div>
                <p className="font-semibold text-sm">{review.userName}</p>
                <p className="text-xs text-muted-foreground">{timeAgo(review.createdAt)}</p>
              </div>
              <StarRating rating={review.rating} size="sm" />
            </div>
            
            <p className="text-sm text-foreground leading-relaxed">{review.comment}</p>
          </div>
        </div>
      </div>

      {/* Business Reply */}
      {review.businessReply && (
        <div className="bg-muted/30 p-4 border-t border-border/50">
          <div className="flex items-start gap-4">
            {/* Business Avatar */}
            <div className="w-8 h-8 rounded-full bg-local-sage flex items-center justify-center flex-shrink-0">
              <Store className="w-4 h-4 text-white" />
            </div>
            
            {/* Reply Content */}
            <div className="flex-1 min-w-0">
              <div className="flex items-center gap-2 mb-1">
                <p className="font-semibold text-sm">{review.businessName}</p>
                <span className="px-2 py-0.5 bg-local-sage/10 text-local-sage text-xs font-medium rounded-full">
                  Negocio
                </span>
              </div>
              <p className="text-xs text-muted-foreground mb-2">
                {timeAgo(review.businessReply.repliedAt)}
              </p>
              <p className="text-sm text-foreground leading-relaxed">
                {review.businessReply.reply}
              </p>
            </div>
          </div>
        </div>
      )}
    </motion.div>
  );
};
